
// AboutUs.js

import React from "react";
import styled, { keyframes } from "styled-components";
import {
  FiTarget,
  FiAward,
  FiClock,
  FiEye,
  FiCheckCircle,
  FiMapPin,
  FiShield,
  FiTool
} from "react-icons/fi";


const fadeUp = keyframes`
from{
  opacity:0;
  transform:translateY(30px);
}
to{
  opacity:1;
  transform:translateY(0);
}
`;



const SectionWrapper = styled.section`

position:relative;

padding:6rem 1.5rem;


background:

linear-gradient(
180deg,
${({theme})=>theme.colors.white},
${({theme})=>theme.colors.bgLight}
);


overflow:hidden;


`;



const Container = styled.div`

max-width:1280px;

margin:0 auto;


`;



const Grid = styled.div`

display:grid;

grid-template-columns:1.15fr .85fr;


gap:5rem;


align-items:center;


@media(max-width:${({theme})=>theme.breakpoints.desktop}){

grid-template-columns:1fr;

gap:3rem;

}


`;



const ContentColumn = styled.div`

animation:${fadeUp}.7s ease;


`;



const Tagline = styled.div`

display:inline-flex;

align-items:center;

gap:8px;


font-size:.8rem;

font-weight:800;

letter-spacing:.1em;

text-transform:uppercase;


color:${({theme})=>theme.colors.primary};


margin-bottom:1rem;


`;



const MainTitle = styled.h2`

font-size:clamp(2rem,4vw,3rem);


font-weight:800;


line-height:1.15;


letter-spacing:-1px;


color:${({theme})=>theme.colors.textDark};


margin-bottom:1.5rem;


`;



const BodyParagraph = styled.p`

font-size:1.08rem;


line-height:1.8;


color:${({theme})=>theme.colors.textMuted};


margin-bottom:2rem;


strong{

color:${({theme})=>theme.colors.textDark};

font-weight:800;

}


`;



const CoreValuesContainer = styled.div`

margin-top:2rem;

`;



const ValuesTitle = styled.h3`

font-size:.95rem;

font-weight:800;


text-transform:uppercase;


letter-spacing:.06em;


color:${({theme})=>theme.colors.textDark};


margin-bottom:1.2rem;


`;



const ValuesGrid = styled.div`

display:grid;

grid-template-columns:repeat(2,1fr);


gap:1rem;


@media(max-width:${({theme})=>theme.breakpoints.mobile}){

grid-template-columns:1fr;

}


`;



const ValueCard = styled.div`

display:flex;

align-items:center;


gap:14px;


padding:1.15rem;


background:${({theme})=>theme.colors.white};


border-radius:16px;


border:1px solid ${({theme})=>theme.colors.border};


box-shadow:

0 8px 20px rgba(15,23,42,.05);


transition:${({theme})=>theme.transitions.default};



&:hover{

transform:translateY(-5px);

border-color:${({theme})=>theme.colors.primary};

box-shadow:

0 15px 30px rgba(15,23,42,.1);

}


span{

font-size:.92rem;

font-weight:700;

color:${({theme})=>theme.colors.textDark};

}


`;



const ValueIcon = styled.div`

width:42px;

height:42px;


display:flex;

align-items:center;

justify-content:center;


border-radius:12px;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


font-size:1.2rem;


`;





/* RIGHT CARD */


const CardColumn = styled.div`

position:relative;


padding:2.5rem;


background:

linear-gradient(
145deg,
#ffffff,
${({theme})=>theme.colors.bgAccent}
);


border-radius:28px;


border:1px solid ${({theme})=>theme.colors.border};


box-shadow:

0 20px 50px rgba(15,23,42,.1);


animation:${fadeUp}.9s ease;



&::before{

content:"";

position:absolute;

top:0;

right:0;


width:120px;

height:120px;


background:${({theme})=>theme.colors.primaryLight};


border-radius:0 28px 0 100%;


opacity:.6;


}



@media(max-width:${({theme})=>theme.breakpoints.mobile}){

padding:1.8rem;

}


`;



const CardHeader = styled.div`

position:relative;

z-index:2;


padding-bottom:1.3rem;


margin-bottom:1.5rem;


border-bottom:1px solid ${({theme})=>theme.colors.border};


h3{

font-size:1.4rem;

font-weight:800;

color:${({theme})=>theme.colors.textDark};

}


p{

margin-top:.4rem;

font-size:.85rem;

color:${({theme})=>theme.colors.textMuted};

}


`;



const InfoList = styled.div`

display:flex;

flex-direction:column;

gap:1.1rem;


`;



const InfoItem = styled.div`

display:flex;

justify-content:space-between;


gap:20px;


font-size:.9rem;


.label{

display:flex;

align-items:center;

gap:8px;

color:${({theme})=>theme.colors.textMuted};

font-weight:600;

}


.value{

text-align:right;

font-weight:800;

color:${({theme})=>theme.colors.textDark};

}


@media(max-width:${({theme})=>theme.breakpoints.mobile}){

flex-direction:column;

gap:4px;


.value{

text-align:left;

}

}


`;



const BadgeVerified = styled.div`

margin-top:2rem;


padding:1rem;


display:flex;

align-items:center;

justify-content:center;


gap:8px;


border-radius:14px;


background:${({theme})=>theme.colors.primaryLight};


color:${({theme})=>theme.colors.primary};


font-size:.85rem;


font-weight:800;


`;




export default function AboutUs(){


const coreValues=[

{
title:"Precision Engineering",
icon:<FiTarget/>
},

{
title:"Premium Materials",
icon:<FiAward/>
},

{
title:"On-Time Delivery",
icon:<FiClock/>
},

{
title:"Complete Transparency",
icon:<FiEye/>
}

];



return(

<SectionWrapper id="about">


<Container>


<Grid>



<ContentColumn>


<Tagline>

<FiTool/>

About Our Company

</Tagline>



<MainTitle>

Crafting Foundations &
Finishing Touches

</MainTitle>



<BodyParagraph>


<strong>
Jisr Al Sahra Plaster & Tiles Cont.
</strong>

is a Sharjah-based contracting company specializing in professional plastering, high-quality wall finishes, and modern floor & wall tiling solutions. We combine technical expertise with skilled craftsmanship to create durable and elegant spaces across UAE.


</BodyParagraph>



<CoreValuesContainer>


<ValuesTitle>

Our Core Principles

</ValuesTitle>



<ValuesGrid>


{

coreValues.map((item,index)=>(


<ValueCard key={index}>


<ValueIcon>

{item.icon}

</ValueIcon>


<span>

{item.title}

</span>


</ValueCard>


))


}



</ValuesGrid>


</CoreValuesContainer>


</ContentColumn>





<CardColumn>



<CardHeader>


<h3>

Jisr Al Sahra Contracting

</h3>


<p>

Government Registered & Licensed Enterprise

</p>


</CardHeader>



<InfoList>


<InfoItem>

<span className="label">

<FiMapPin/>

Jurisdiction

</span>


<span className="value">

Sharjah, UAE

</span>


</InfoItem>



<InfoItem>

<span className="label">

<FiShield/>

License No

</span>


<span className="value">

945516

</span>


</InfoItem>



<InfoItem>

<span className="label">

<FiTool/>

Specialty

</span>


<span className="value">

Plastering & Tiling

</span>


</InfoItem>



<InfoItem>

<span className="label">

<FiMapPin/>

Service Reach

</span>


<span className="value">

Sharjah & All UAE

</span>


</InfoItem>



</InfoList>



<BadgeVerified>

<FiCheckCircle/>

Verified Commercial Entity (SEDD Registered)

</BadgeVerified>



</CardColumn>



</Grid>


</Container>


</SectionWrapper>


);

}

